
/* injects from baggage-loader */
require('./style.scss');

import React, { useRef, useState, useEffect } from "react";
import { t } from "@common/helpers/translator";

function Loader({ component, withoutMessage }) {
	useEffect(() => {
		const id = setTimeout(() => {
			if (window?.jsobject?.writeLog) {
				window.jsobject.writeLog(component);
			}
		}, 15000);

		return () => clearTimeout(id);
	}, []);

	const LoaderTimeout = 15000;
	const [timedOut, setTimedOut] = useState(false);
	const appearTimeout = useRef();

	useEffect(() => {
	    appearTimeout.current = setTimeout(() => {
	        setTimedOut(true);
	    }, LoaderTimeout);

	    return () => clearTimeout(appearTimeout.current);
	}, []);

	if (timedOut && withoutMessage) return null;

	return !timedOut ? (
	    <div className="md-progress-circular md-theme" />
	) : <div className="md-no-data">
	    <h2>{t('Something went wrong with loading the data. Please try again later.')}</h2>
	</div>;

	return <div className="md-progress-circular md-theme" />;
}
export default Loader;
